import { useUpdateDefaultBrandingTheme } from '@/hooks/requests/useBrandingThemes';
import { BrandingThemeItem } from '@/types/brandingThemes';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Radio,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';
import { SVButton } from '@/components/core';

type BrandingThemesDefaultThemeRadioProps = {
  theme: BrandingThemeItem;
};

export default function BrandingThemesDefaultThemeRadio({
  theme,
}: BrandingThemesDefaultThemeRadioProps) {
  const [open, setOpen] = useState(false);
  const { updateDefaultBrandingTheme, isUpdateDefaultBrandingThemePending } =
    useUpdateDefaultBrandingTheme();

  async function handleUpdateDefaultBrandingTheme() {
    try {
      await updateDefaultBrandingTheme(theme.uuid);
      setOpen(false);
      showToast({
        type: 'success',
        data: {
          content: 'Default branding theme has been updated',
        },
      });
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  return (
    <>
      <Radio
        checked={theme.isProgramDefault}
        onChange={() => setOpen(true)}
        name={`${theme.name}-default-theme`}
        aria-label={`make ${theme.name} the default theme`}
      />
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={() => setOpen(false)}>
        <DialogContent>
          <Typography variant="h6" component="h2">
            Change Default Branding Theme?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to change the default Program Theme to "
            {theme.name}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <SVButton variant="tertiary" onClick={() => setOpen(false)}>
            Close
          </SVButton>
          <SVButton
            isLoading={isUpdateDefaultBrandingThemePending}
            onClick={handleUpdateDefaultBrandingTheme}>
            Confirm
          </SVButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
